// extracted by mini-css-extract-plugin
module.exports = {"active":"active__2kQYI","topper":"topper__-OdUK","left":"left__2QnxB","wrap":"wrap__2n6az","right":"right__MUC4s","social":"social__1JCO9","info":"info__1GyXp"};